// extracted by mini-css-extract-plugin
export default {"category":"Category_category__3yR00","categoryImg":"Category_categoryImg__eiMUI","color":"Category_color__zwA30","categoryContent":"Category_categoryContent__-9SCc"};